import type { RuntimeEnvironment } from '../schemas';
import { webConfig } from '../webConfig';

export const env: RuntimeEnvironment = process.env.FIRESTORE_EMULATOR_HOST
    ? 'test'
    : (process.env.NODE_ENV! as RuntimeEnvironment);

export const isDevelopment: boolean = env !== 'production' && env !== 'test';

/**
 * Returns true if we are running in production.
 *
 * This property is safe and defaults to TRUE unless we are in a known
 * non-production environment.
 */
export const isProduction = !(
    // Staging
    (
        webConfig.firebase.projectId === 'gitbook-x-staging' ||
        // dev environments
        webConfig.firebase.projectId.startsWith('gitbook-x-dev') ||
        webConfig.firebase.projectId.startsWith('getsquad-dev') ||
        // tests
        webConfig.firebase.projectId === 'gitbook-x-tests'
    )
);
